import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints } from '@rossum/api-client';
import { CreateNotePayload } from '@rossum/api-client/notes';
import { api } from '../../../../lib/apiClient';
import { notify } from '../../../toaster';
import { GET_COMMENTS_QUERY_KEY } from '../../core';

const MUTATION_KEY_CREATE_COMMENT = 'create-comment';

export const useCreateComment = () => {
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationKey: [MUTATION_KEY_CREATE_COMMENT] as const,
    mutationFn: (payload: CreateNotePayload) =>
      api.request(endpoints.notes.create(payload)),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [GET_COMMENTS_QUERY_KEY],
      });
      notify.default({
        title: intl.formatMessage({
          id: 'components.documentComments.toast.createSuccess',
        }),
      });
    },
    onError: () =>
      notify.error({
        title: intl.formatMessage({
          id: 'components.documentComments.toast.createError',
        }),
      }),
  });
};
